import type { SimplePaletteColorOptions } from '@mui/material'

const Color: SimplePaletteColorOptions = {
  main: '#FFC107',
  light: '#fff350',
  dark: '#c79100',
  contrastText: 'rgba(0, 0, 0, 0.87)',
}

export default Color
